import React from 'react'
import styled from 'styled-components'
import { Trans, useTranslation } from '~/i18n'
import getcdn from '~/modules/get_cdn_link'
import breakpoints from '../UI/breakpoints'
import SharedTitle from '../UI/SharedTitle'

const Investors = () => {
  const [t] = useTranslation()
  return (
    <Root>
      <SharedTitle style={{ fontWeight: 'normal' }} centered>
        <Trans i18nKey="Nhà đầu tư của Infina"></Trans>
      </SharedTitle>

      <Content>
        <PartnersImage src={getcdn('/images/home/investors-3.png')} alt="Our investors" />
        <PartnersImageMobile src={getcdn('/images/home/investors-mobile-3.png')} alt="Our investors" />
      </Content>
    </Root>
  )
}

export default Investors

//#region
const Root = styled.div`
  padding: 40px 20px;
  background-color: #ebf3ff;
  ${breakpoints.md} {
    padding: 40px 80px;
  }
`

const Content = styled.div`
  background-color: white;
  border-radius: 24px;
  padding: 0;
  margin-top: 32px;

  ${breakpoints.md} {
    padding: 65px 75px;
  }
`

const PartnersImage = styled.img`
  display: none;

  ${breakpoints.md} {
    width: 100%;
    display: block;
  }
`

const PartnersImageMobile = styled.img`
  width: 100%;

  ${breakpoints.md} {
    display: none;
  }
`
//#endregion
